let inject = ['$q','$http', 'ngAuthSettings', 'AuthTokenFactory', 'SharedService', 'SessionService'];
class PayZoneDashboardService {
  constructor ($q, $http, ngAuthSettings, AuthTokenFactory, SharedService, SessionService) {
    this.$q = $q;
    this.$http = $http;
    this.ngAuthSettings = ngAuthSettings;
    this.AuthTokenFactory = AuthTokenFactory;
    this.SharedService = SharedService;
    this.SessionService = SessionService;
  }
  
  getPlants(documentNumber, reference){
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'GET',
        url: this.ngAuthSettings.apiServiceBaseUri + '/recaudos/recaudos/cartera-centros-operaciones?terceroDocumento=' + documentNumber + (reference ? ('&codigoCentroOperacion=' + reference) : ''),
        cache : true
      }).then((response) => {
        resolve(response.data);
      }, (reason) => {
        reject(reason);
      });
    });
  }
}

PayZoneDashboardService.$inject = inject;

export default PayZoneDashboardService;



/** WEBPACK FOOTER **
 ** ./www/components/pay-zone/dashboard/dashboard.service.js
 **/